/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import CompletionWarning from 'bundles/degree-home/components/v3-dpm/components/CompletionWarning';
import type { GPA } from 'bundles/degree-home/components/v3-dpm/types/gradeTypes';

type Props = {
  level: 'category' | 'curriculum';
  hasGradeWarning: boolean | undefined;
  hasGPAWarning: boolean | undefined;
  gpa: GPA | undefined;
};

const CompletionWarningContainer = ({ level, hasGradeWarning, hasGPAWarning, gpa }: Props) => {
  return (
    <div
      css={() => css`
        > div {
          margin-top: var(--cds-spacing-200);
        }
      `}
    >
      {hasGPAWarning && typeof gpa === 'number' && <CompletionWarning variant="gpa" level={level} gpa={gpa} />}
      {hasGradeWarning && <CompletionWarning variant="grade" level={level} />}
    </div>
  );
};

export default CompletionWarningContainer;
